// @ts-nocheck
import PropTypes from "prop-types";
import {useTranslation} from "react-i18next";

const WithdrawalConfirm = ({selectBankAccount, withdrawalAmount}) => {
  const {t} = useTranslation();

  const isMobile = window.innerWidth <= 768;

  return (
    <>
      {/* Title - Confirmacion de retiro */}
      <h4
        style={{
          margin: isMobile ? 0 : "1rem 0 4rem 0",
          fontWeight: 700,
          fontSize: isMobile ? 16 : undefined,
        }}
      >
        {t("withdrawalSteps_3_Confirm")}
      </h4>

      {/* Bank and Phone Information Container */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          maxWidth: "600px",
          margin: "0 auto",
          gap: isMobile ? "0" : "0",
        }}
      >
        {/* Bank information */}
        <div
          style={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            alignItems: "center",
            gap: isMobile ? "8px" : "20px",
            margin: "1rem 0",
            justifyContent: isMobile ? "center" : "flex-start",
            width: isMobile ? "auto" : "100%",
            textAlign: isMobile ? "center" : "left",
          }}
        >
          <h4
            style={{
              fontSize: isMobile ? 16 : undefined,
              margin: 0,
              fontWeight: 500,
              width: isMobile ? "auto" : "100px",
              textAlign: isMobile ? "center" : "left",
            }}
          >
            {t("withdrawalSteps_3_Bank")}:
          </h4>
          <h4
            style={{
              fontSize: isMobile ? 16 : undefined,
              margin: 0,
              fontWeight: 400,
              textAlign: isMobile ? "center" : "left",
              flex: isMobile ? "none" : 1,
            }}
          >
            {selectBankAccount.bankName}
          </h4>
        </div>

        {/* Phone information */}
        <div
          style={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            alignItems: "center",
            gap: isMobile ? "8px" : "20px",
            margin: "1rem 0",
            justifyContent: isMobile ? "center" : "flex-start",
            width: isMobile ? "auto" : "100%",
            textAlign: isMobile ? "center" : "left",
          }}
        >
          <h4
            style={{
              fontSize: isMobile ? 16 : undefined,
              margin: 0,
              fontWeight: 500,
              width: isMobile ? "auto" : "120px",
              textAlign: isMobile ? "center" : "left",
            }}
          >
            {t("withdrawalSteps_3_PhoneNumber")}:
          </h4>
          <h4
            style={{
              fontSize: isMobile ? 16 : undefined,
              margin: 0,
              fontWeight: 400,
              textAlign: isMobile ? "center" : "left",
              flex: isMobile ? "none" : 1,
            }}
          >
            {selectBankAccount.phone}
          </h4>
        </div>
      </div>

      {/* "Vas a retirar" title centered */}
      <h4
        style={{
          textAlign: "center",
          margin: isMobile ? 0 : "4rem 0 0 0",
          fontSize: isMobile ? 16 : 18,
          fontWeight: 500,
        }}
      >
        {isMobile ? t("withdrawalSteps_3_Amount") : t("withdrawalSteps_3_YouWillWithdraw")}:
      </h4>

      {/* Amount section with yellow background */}
      <div
        style={{
          width: isMobile ? "auto" : "624px",
          height: isMobile ? "auto" : "54px",
          borderRadius: isMobile ? "0" : "40px",
          background: isMobile ? "transparent" : "#FEF8AD",
          opacity: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "var(--space-3)",
          margin: "1rem auto",
          maxWidth: "100%",
          padding: isMobile ? "20px 0" : "0",
        }}
      >
        <h4
          style={{
            fontFamily: "Poppins",
            fontWeight: isMobile ? 700 : 400,
            fontSize: isMobile ? "21px" : "31px",
            lineHeight: isMobile ? "28px" : "35px",
            textAlign: "center",
            margin: 0,
            color: isMobile ? "var(--color-secondary)" : "var(--color-gray-medium-3)",
          }}
        >
          {new Intl.NumberFormat("es-BO", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(withdrawalAmount)}{" "}
          Bs.
        </h4>
      </div>
    </>
  );
};

WithdrawalConfirm.propTypes = {
  selectBankAccount: PropTypes.object.isRequired,
  withdrawalAmount: PropTypes.number.isRequired,
};

export default WithdrawalConfirm;
